import React, { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";

const CONNECTION_RESPONSE_URL =
  "https://us-central1-ibchat-d0d57.cloudfunctions.net/connectionResponse";

const ConnectionResponse = () => {
  const [searchParams] = useSearchParams();

  const [status, setStatus] = useState("processing");
  const [message, setMessage] = useState("");

  // Prevent duplicate API call in React StrictMode
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Don't execute twice
    if (hasProcessed.current) {
      return;
    }

    hasProcessed.current = true;

    const processResponse = async () => {
      try {
        const requestId = searchParams.get("requestId");
        const token = searchParams.get("token");
        const action = searchParams.get("action");

        console.log("Connection Response Params:", {
          requestId,
          token,
          action,
        });

        if (!requestId || !token || !action) {
          setStatus("error");
          setMessage("Invalid connection request link.");
          return;
        }

        if (!["accept", "reject"].includes(action)) {
          setStatus("error");
          setMessage("Invalid connection action.");
          return;
        }

        const url = new URL(CONNECTION_RESPONSE_URL);

        url.searchParams.set("requestId", requestId);
        url.searchParams.set("token", token);
        url.searchParams.set("action", action);

        console.log("Calling:", url.toString());

        const response = await fetch(url.toString(), {
          method: "GET",
        });

        console.log("Response status:", response.status);

        const responseText = await response.text();
        const responseJson = JSON.parse(responseText);

        console.log("Firebase response:", responseText.toString());
        
        if (!response.ok) {
          setStatus("error");
          
          if (response.status === 404) {
            setMessage("Connection request not found.");
          } else if (response.status === 403) {
            setMessage("This connection request link is invalid.");
          } else if (response.status === 409) {
            setMessage(`This connection request has already been ${responseJson.status}.`);
          } else if (response.status === 410) {
            setMessage("This connection request has expired.");
          } else {
            setMessage("Unable to process the connection request.");
          }

          return;
        }

        if (action === "accept") {
          setStatus("success");
          setMessage("Connection request accepted successfully.");
        } else {
          setStatus("success");
          setMessage("Connection request rejected successfully.");
        }
      } catch (error) {
        console.error("Connection response error:", error);

        setStatus("error");
        setMessage(
          "Something went wrong while processing the connection request.",
        );
      }
    };

    processResponse();
  }, [searchParams]);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#f5f5f5",
        padding: "20px",
      }}
    >
      <div
        style={{
          background: "#fff",
          padding: "40px",
          borderRadius: "12px",
          maxWidth: "500px",
          width: "100%",
          textAlign: "center",
          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
        }}
      >
        {status === "processing" && (
          <>
            <h2>Processing...</h2>

            <p>Please wait while we process your connection request.</p>
          </>
        )}

        {status === "success" && (
          <>
            <h2>
              {searchParams.get("action") === "accept"
                ? "Connection Request Accepted"
                : "Connection Request Rejected"}
            </h2>

            <p>{message}</p>
          </>
        )}

        {status === "error" && (
          <>
            {/* <h2>Oops!</h2> */}

            <p>{message}</p>
          </>
        )}
      </div>
    </div>
  );
};

export default ConnectionResponse;
